@if (path) {
    <a class="d-block" (click)="goToPath(path)" [innerHTML]="innerHtml"></a>
}
@if (action) {
    <span class="d-block" (click)="actionClicked.emit()" [innerHTML]="innerHtml"></span>
}
@if (icon) {
    <div>
        <kui-icon [name]="icon.name" [ngStyle]="{ color: icon.color }" class="mr-2"></kui-icon>
        <span [innerHTML]="innerHtml"></span>
    </div>
}
@if (!path && !action && !icon) {
    <span [innerHTML]="innerHtml"></span>
}
